const TeamCarouselItem = ({ teamMember: { name, jobTitle, jobDescription, link, image } }) => {
    const Tag = link ? 'a' : 'div';
    return (
        <Tag
            href={link ? link : undefined}
            target={link ? '_blank' : undefined}
            rel={link ? 'noopener noreferrer' : undefined}
            className="team-carousel-item flex-column align-center"
        >
            <div className="image-wrapper">
                <img src={image} alt={name} />
            </div>

            <div className="content-wrapper flex-column align-center">
                <h3>{name}</h3>
                <h4>{jobTitle}</h4>
                <p>{jobDescription}</p>
            </div>
        </Tag>
    );
};

export default TeamCarouselItem;
